import { Injectable } from '@angular/core';

import { TeaserBetConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, of, tap } from 'rxjs';

import { TeaserBetApiService, TeaserPriceDetails } from './teaser-bet-api.service';

@Injectable()
export class TeaserBetNewService {
    private expiry: number;
    private teaserPrices: TeaserPriceDetails;

    constructor(
        private api: TeaserBetApiService,
        private teaserBetConfig: TeaserBetConfig,
    ) {}

    getLatestTeaserPrices(): Observable<TeaserPriceDetails> {
        if (this.teaserPrices && this.expiry > new Date().getTime()) {
            return of(this.teaserPrices);
        }

        return this.api.getLatestTeaserPrices().pipe(
            tap((data) => {
                const dt = new Date();
                dt.setHours(dt.getHours() + this.teaserBetConfig.priceTableCache.frontEndDuration);
                this.expiry = dt.getTime();
                this.teaserPrices = data;
            }),
        );
    }
}
